import { linkTo } from '@mcfe/tools';

export const getFileName = (fileUrl) => {
    const match = fileUrl.match(/mall-fe-files\/(.*)/);
    if (match && match[1]) {
        return match[1];
    }
    return fileUrl || '--';
};

// 跳转到非/vss路径
// 当前页面路径，跳转条件
export const redirectToNonVssPath = (currentPath, redirectCondition) => {
    if (redirectCondition && currentPath.includes('/vss')) {
        const newPath = currentPath.replace('/vss', '');
        const queryParams = window.location.search;
        window.location.href = `${newPath}${queryParams}`;
    }
};


// 获取详情-判断是否有附件解决报错
export const getFileList = (files) => {
    if (Array.isArray(files)) return files;
    if (typeof files === 'string') return files.split(',');
    return [];
};

// 保存后返回列表-判断是否显示菜单和是否只允许操作pb招投标（多处使用，逻辑相同，单独维护）
export const cancelLinkToPath = (isBindSupplyComponent) => {
    if (isBindSupplyComponent === 'Layout') {
        linkTo('/price/onlineBid/list.html');
    } else {
        linkTo('/vss/price/onlineBid/list.html', { type: 'pb' });
    }
};
